import { Tooltip as SgTooltip, TooltipProps as SgTooltipProps } from '@sgme/ui';

export type SpTooltipProps = SgTooltipProps & { disabled?: boolean };

export function SpTooltip({ children, disabled = false, ...props }: SpTooltipProps) {
  return disabled ? children : <SgTooltip {...props}>{children}</SgTooltip>;
}
